import type { SignupPath } from '~/constants/market';

type LandingEventParams = Record<string, string | number | boolean | null>;

/** Landing analytics: GTM dataLayer + the first-party /api/tracking/event pipeline. */
export const useLandingTracking = () => {
  const { sendEventToBackend } = useTracking();
  const { page, track } = useLandingPage();

  const trackLandingEvent = (event: string, params: LandingEventParams = {}) => {
    if (typeof window === 'undefined') return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    } catch {
      // Analytics never blocks navigation.
    }
    void sendEventToBackend(event, params);
  };

  const trackCtaClick = (section: string, path: SignupPath | null = null) =>
    trackLandingEvent('landing_cta_clicked', { page: page.value, section, track: track.value, path });

  return {
    trackLandingEvent,
    trackCtaClick,
  };
};
